import React, { Component } from "react";
import "antd/dist/antd.css";
import { withRouter } from "react-router";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Card,
  Upload,
  message,
  Icon,
  Select,
  Spin,
} from "antd";
import { Link } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import { InboxOutlined, PlusCircleOutlined } from "@ant-design/icons";
import Amplify, { Storage } from "aws-amplify";
import awsConfigure from "../../Config/AwsConfig";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, list, add, update } from "../../api/Apis";
import { noWhitespaceRule, formatWithInchSymbol } from "../../utils/Utils";
import ErrorPage from "../ErrorPage";
import imageCompression from 'browser-image-compression';

Amplify.configure(awsConfigure);

const { Option } = Select;
const { Dragger } = Upload;
// let id = 0;

class AddProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      confirmDirty: false,
      fileList: [],
      category: [],
      productsData: [],
      totalProductsData: [],
      sizesData: [],
      images: [],
      categoriesList: [],
      subCategoriesList: [],
      yardLocations: [],
      title: "Add new Product",
      btntitle: "Save",
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
    console.log(this.state)
  }

  remove = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    if (keys.length === 0) {
      return;
    }
    form.setFieldsValue({
      keys: keys.filter((key) => key !== k),
    });
  };

  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    console.log(keys);
    const nextKeys = keys.concat(keys.length);
    console.log(nextKeys);
    form.setFieldsValue({
      keys: nextKeys,
    });
  };

  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);

  componentDidMount() {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    this.setState({
      dataLoadingStatus: true,
      yardLocations: orgDetails["yardLocations"].sort((a, b) =>
        a["locationName"] > b["locationName"] ? 1 : -1
      ),
    });
    let query = {
      dataType: "category",
      recordStatus: true,
    };
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
        this.setState({
          categoriesList: result.data.sort((a, b) =>
            a["name"] > b["name"] ? 1 : -1
          ),
        });
        query = {
          dataType: "subCategory",
          recordStatus: true,
        };
        list(AppConfigs["entityNames"]["masterData"], query).then((subCat) => {
          if (subCat.success) {
            this.setState({
              subCategoriesList: subCat.data.sort((a, b) =>
                a["name"] > b["name"] ? 1 : -1
              ),
              dataLoading: false,
            });
          } else {
            console.log(subCat.errors);
            this.setState({
              dataLoading: false,
            });
          }
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
    if (this.props.match.params.id) {
      this.setState({
        dataLoadingStatus: true,
        title: "Edit Product",
        btntitle: "Update",
      });
      getDetails(
        AppConfigs["entityNames"]["products"],
        this.props.match.params.id
      ).then((result) => {
        if (result.success) {
          let totalProductsData = result.data;
          let sizesData = result.data.sizes;
          this.props.form.setFieldsValue({
            productCategory: totalProductsData.productCategory,
            productSubCategory: totalProductsData.productSubCategory,
            productCode: totalProductsData.productCode,
            productName: totalProductsData.productName,
            description: totalProductsData.description,
            productOrigin: totalProductsData.productOrigin
              ? totalProductsData.productOrigin
              : [],
            // "images": totalProductsData.images,
          });

          this.setState({
            images: totalProductsData.images,
            category: totalProductsData.productCategory,
          });
          if (sizesData.length > 0) {
            this.props.form.setFieldsValue({
              size: sizesData[0].size,
              ton: sizesData[0].ton,
              yard: sizesData[0].yard,
              pallet: sizesData[0].pallet,
              supersack: sizesData[0].supersack,
              sizeUploadImg: sizesData[0].sizeUploadImg,
            });
          }
          if (sizesData.length > 1) {
            let keys = [],
              cou = 0;
            while (cou < sizesData.length - 1) {
              keys.push(cou);
              console.log(cou);
              cou++;
            }
            this.props.form.setFieldsValue({
              keys: keys,
            });
            console.log(keys);
          }
          sizesData.map((sdata, index) => {
            if (index !== 0) {
              let sizeVariable = index - 1 + "_size";
              let tonVariable = index - 1 + "_ton";
              let palletVariable = index - 1 + "_pallet";
              let supersackVariable = index - 1 + "_supersack";
              let yardVariable = index - 1 + "_yard";
              let imageVariable = index - 1 + "_sizeUploadImg";
              this.props.form.setFieldsValue({
                [sizeVariable]: sdata.size,
                [tonVariable]: sdata.ton,
                [palletVariable]: sdata.pallet,
                [supersackVariable]: sdata.supersack,
                [yardVariable]: sdata.yard,
                [imageVariable]: sdata.sizeUploadImg,
              });
            }
            return true;
          });
        } else {
          console.log(result.errors);
          this.setState({
            dataLoadingStatus: false,
          });
        }
      });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
  
        const { keys } = values;
        let productSize = [];
        let imageKeys = [];
        let imgName = values["sizeUploadImg"]
          ? values["sizeUploadImg"].split("\\")[
              values["sizeUploadImg"].split("\\").length - 1
            ]
          : null;
        let ton = 0;
        if (
          values["productCategory"] ===
            "37638d60-2b19-11eb-b05c-a3fa7baaf1b4" ||
          values["productCategory"] === "3f252db0-2b19-11eb-b05c-a3fa7baaf1b4"
        ) {
          ton = 1.5;
        } else {
          ton = 1;
        }
        productSize.push({
          size: formatWithInchSymbol(values["size"]),
          ton: ton,
          supersack: values["supersack"],
          pallet: values["pallet"],
          truckload: (ton * 24).toString(),
          sizeUploadImg: imgName,
        });
  
        await Promise.all(
          keys.map(async (key) => {
            if (values[key + "_sizeUploadImg"]) {
              imgName =
                values[key + "_sizeUploadImg"].split("\\")[
                  values[key + "_sizeUploadImg"].split("\\").length - 1
                ];
            } else {
              imgName = null;
            }
  
            productSize.push({
              size: formatWithInchSymbol(values[key + "_size"]),
              ton: ton,
              supersack: values[key + "_supersack"],
              pallet: values[key + "_pallet"],
              truckload: (ton * 24).toString(),
              sizeUploadImg: imgName,
            });
          })
        );
  
        let data = {
          entityData: {
            productCategory: values["productCategory"],
            productSubCategory: values["productSubCategory"],
            productCode: values["productCode"],
            productName: values["productName"],
            description: values["description"],
            productOrigin: values["productOrigin"],
            linkId: null,
            sizes: productSize,
          },
        };
  
        let imgCount = 0;
        await Promise.all(
          this.state.fileList.map(async (file) => {
            let fileName =
              values["productCode"].replace(/\s+/g, "") + "_" + file["name"];
            try {
              const compressedImage = await imageCompression(file, {
                maxSizeMB: 5,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
              });
  
              await Storage.put(fileName, compressedImage, {
                contentType: compressedImage.type,
              });
  
              imgCount += 1;
              let isSizeImage = false;
  
              productSize.forEach((img) => {
                if (img.sizeUploadImg === file["name"]) {
                  img["sizeUploadImg"] = fileName;
                  isSizeImage = true;
                }
              });
  
              if (!isSizeImage) {
                imageKeys.push(fileName);
              }
  
              if (this.state.fileList.length === imgCount) {
                if (imageKeys.length > 0) {
                  data["entityData"]["images"] = imageKeys;
                } else {
                  data["entityData"]["images"] = this.state.images;
                }
  
                productSize.forEach((img) => {
                  if (img.sizeUploadImg === null) {
                    img["sizeUploadImg"] = data["entityData"]["images"][0];
                  }
                });
  
                data["entityData"]["sizes"] = productSize;
  
                if (this.props.match.params.id) {
                  update(
                    AppConfigs["entityNames"]["products"],
                    this.props.match.params.id,
                    data
                  ).then((result) => {
                    if (result.success) {
                      this.props.history.push("/app/products");
                    } else {
                      this.setState({
                        loading: false,
                      });
                      console.log(result.errors);
                    }
                  });
                } else {
                  data["entityData"]["isActive"] = true;
                  add(AppConfigs["entityNames"]["products"], data).then(
                    (result) => {
                      if (result.success) {
                        this.props.history.push("/app/products");
                      } else {
                        this.setState({
                          loading: false,
                        });
                        console.log(result.errors);
                      }
                    }
                  );
                }
              }
            } catch (error) {
              console.error("Error compressing image:", error);
            }
          })
        );
  
        if (this.state.fileList.length === 0) {
          if (this.props.match.params.id) {
            update(
              AppConfigs["entityNames"]["products"],
              this.props.match.params.id,
              data
            ).then((result) => {
              if (result.success) {
                this.props.history.push("/app/products");
              } else {
                this.setState({
                  loading: false,
                });
                console.log(result.errors);
              }
            });
          } else {
            data["entityData"]["isActive"] = true;
            add(AppConfigs["entityNames"]["products"], data).then((result) => {
              if (result.success) {
                this.props.history.push("/app/products");
              } else {
                this.setState({
                  loading: false,
                });
                console.log(result.errors);
              }
            });
          }
        }
      }
    });
  };
  
  render() {
    const props = {
      name: "file",
      multiple: true,
      action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
      onChange(info) {
        const { status } = info.file;
        if (status !== "uploading") {
          // this.fileList = info.fileList;
          // // this.setState({
          // //     fileList:info.fileList
          // // })
        }
        if (status === "done") {
          message.success(`${info.file.name} file uploaded successfully.`);
        } else if (status === "error") {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
      onRemove: (file) => {
        this.setState((state) => {
          let index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
    };
    const { getFieldDecorator, getFieldValue } = this.props.form;

    getFieldDecorator("keys", { initialValue: [] });
    const keys = getFieldValue("keys");
    const formItems = keys.map((k, index) => (
      <div key={index}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24}>
              <Form.Item
                label={<span style={{ color: "#7B8190" }}>Size</span>}
                required={true}
                key={k}
              >
                {getFieldDecorator(k + "_size", {
                  validateTrigger: ["onChange", "onBlur"],
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message:
                        "Please input your Product Size or delete this field.",
                    },
                  ],
                })(<Input addonAfter='"' style={{ width: "95%" }} />)}
              </Form.Item>
            </Col>
            {this.state.category === "37638d60-2b19-11eb-b05c-a3fa7baaf1b5" && (
              <Col lg={4} md={4} sm={24} xs={24}>
                <Form.Item
                  label={
                    <span style={{ color: "#7B8190" }}>
                      Price Per Supersack
                    </span>
                  }
                  required={true}
                  key={k}
                >
                  {getFieldDecorator(k + "_supersack", {
                    validateTrigger: ["onChange", "onBlur"],
                    rules: [
                      {
                        required: true,
                        whitespace: true,
                        message:
                          "Please input your Product Price Per Supersac or delete this field.",
                      },
                    ],
                  })(<Input addonBefore="$" style={{ width: "95%" }} />)}
                </Form.Item>
              </Col>
            )}
            {/* <Col lg={4} md={4} sm={24} xs={24}>
              <Form.Item
                label={<span style={{ color: "#7B8190" }}>Price Per Yard</span>}
                required={true}
                key={k}
              >
                {getFieldDecorator(k + "_yard", {
                  validateTrigger: ["onChange", "onBlur"],
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message:
                        "Please input your Product Price Per Yard or delete this field.",
                    },
                  ],
                })(<Input addonBefore="$" style={{ width: "95%" }} />)}
              </Form.Item>
            </Col> */}
            {this.state.category === "3f252db0-2b19-11eb-b05c-a3fa7baaf1b4" && (
              <Col lg={4} md={4} sm={24} xs={24}>
                <Form.Item
                  label={
                    <span style={{ color: "#7B8190" }}>Price Per Pallet</span>
                  }
                  required={true}
                  key={k}
                >
                  {getFieldDecorator(k + "_pallet", {
                    validateTrigger: ["onChange", "onBlur"],
                    rules: [
                      {
                        required: true,
                        whitespace: true,
                        message:
                          "Please input your Product Price Per Pallet or delete this field.",
                      },
                    ],
                  })(<Input addonBefore="$" style={{ width: "95%" }} />)}
                </Form.Item>
              </Col>
            )}
            <Col lg={6} md={6} sm={24} xs={24}>
              <Form.Item
                label={
                  <span
                    style={{
                      color: "#7B8190",
                      fontSize: "14px",
                      marginLeft: "50px",
                    }}
                  >
                    Upload
                  </span>
                }
                required={false}
                key={k}
              >
                {getFieldDecorator(k + "_sizeUploadImg", {
                  // rules: [{ required: this.props.match.params.id ? false : true, message: 'Please upload Image!' }],
                })(
                  <div className="addproduct-uploadbtn">
                    <Upload
                      {...props}
                      setFieldsValue={this.state.sizeUploadImg}
                    >
                      <Button>
                        <Icon type="upload" />
                        Upload
                      </Button>
                    </Upload>
                  </div>
                )}
              </Form.Item>
            </Col>
            <Col
              lg={2}
              md={2}
              sm={24}
              xs={24}
              style={{ marginTop: "auto", marginBottom: "auto" }}
            >
              {keys.length > 0 ? (
                <Icon
                  className="dynamic-delete-button"
                  type="minus-circle-o"
                  onClick={() => this.remove(k)}
                  title="remove"
                  style={{ marginTop: "55px" }}
                />
              ) : null}
            </Col>
          </Row>
        </Col>
      </div>
    ));

    // let categories = { "BULK GRAVEL": ["NEW ENGLAND RIVER ROCK", "BAYSIDE SKIMMERS", "WINCHESTER RIVER ROCK", "CAPE COD RIVER ROCK", "BERKSHIRE BLEND", "BOSTON PURPLE", "CRUSHED COLOR BLEND", "LAKESIDE RIVER ROCK", "ICE BLUE", "GLACIER RIVER ROCK", "CATSKILL RIVER ROCK", "WHITE MARBLE STONE", "SLATE", "SAND", "HARVEST BLEND", "WHITE RIVER ROCK", "LIBERTY PINK"], "PALLETIZED STONE": ["CRUSHED STONE", "PREMIUM STONE LINE", "PALLETIZED RIVER ROCK", "VENEER / FLAGSTONE"] }

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div
        style={{
          position: "absolute",
          top: "115px",
          paddingLeft: "25%",
          paddingRight: "25%",
        }}
        className="addproduct-container"
      >
        <Spin spinning={this.state.dataLoading}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className="site-card-border-less-wrapper">
              <Card title={this.state.title} style={{ borderRadius: "10px" }}>
                <Form onSubmit={this.handleSubmit}>
                  <Row gutter={10}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Product Category
                          </span>
                        }
                      >
                        {getFieldDecorator("productCategory", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Product Category!",
                            },
                          ],
                        })(
                          <Select
                            placeholder={"Category"}
                            onChange={(category) => {
                              this.setState({ category: category });
                            }}
                          >
                            {this.state.categoriesList.map((cat) => (
                              <Option key={cat.id} value={cat.id}>
                                {cat.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Product Sub-Category
                          </span>
                        }
                      >
                        {getFieldDecorator("productSubCategory", {
                          rules: [
                            {
                              required: false,
                              message:
                                "Please input your Product Sub-Category!",
                            },
                          ],
                        })(
                          <Select placeholder={"Sub-Category"}>
                            {this.state.subCategoriesList
                              .filter(
                                (subCat) =>
                                  subCat.categoryId === this.state.category
                              )
                              .sort((a, b) => (a["name"] > b["name"] ? 1 : -1))
                              .map((subCat) => (
                                <Option key={subCat.id} value={subCat.id}>
                                  {subCat.name}
                                </Option>
                              ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Product Code
                          </span>
                        }
                      >
                        {getFieldDecorator("productCode", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Product Code!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Product Name
                          </span>
                        }
                      >
                        {getFieldDecorator("productName", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Product Name!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Description
                          </span>
                        }
                      >
                        {getFieldDecorator("description", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Product Description!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<TextArea />)}
                      </Form.Item>
                    </Col>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Location
                          </span>
                        }
                      >
                        {getFieldDecorator("productOrigin", {
                          rules: [
                            {
                              required: true,
                              type: "array",
                              message: "Please select your product Origin!",
                            },
                          ],
                        })(
                          <Select
                            mode="multiple"
                            placeholder="Select product origin"
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {this.state.yardLocations.map((location) => (
                              <Option value={location.id} key={location.id}>
                                {location.locationName}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "2%" }}
                    >
                      <Form.Item className="Formitem">
                        {getFieldDecorator("upload", {
                          // rules: [
                          //   {
                          //     required: this.props.match.params.id
                          //       ? false
                          //       : true,
                          //     message: "Please upload Image!",
                          //   },
                          // ],
                        })(
                          <div className="customer-price-upload">
                            <Dragger
                              {...props}
                              style={{ height: "333px", position: "relative" }}
                              setFieldsValue={this.state.uploadImg}
                            >
                              {this.state.images && this.state.fileList.length > 0 ? (
                                <div className="background-image-container">
                                  {this.state.fileList.map((file) => (
                                    <div
                                      key={file.name}
                                      className="background-image"
                                      style={{
                                        backgroundImage: `url(${URL.createObjectURL(file)})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                      }}
                                    >
                                      {/* Additional content can be added here */}
                                      <img
                                        src={URL.createObjectURL(file)}
                                        alt=""
                                        style={{ display: "none" }} // Hide the actual image
                                      />
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div>
                                  <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                  </p>
                                  <p className="ant-upload-text">Drag and drop Image here</p>
                                  <p className="ant-upload-hint">or just click to browse files</p>
                                </div>
                              )}
                            </Dragger>
                          </div>
                        )}
                      </Form.Item>

                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col lg={4} md={4} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Size
                          </span>
                        }
                      >
                        {getFieldDecorator("size", {
                          rules: [
                            {
                              required: true,
                              message: "Please input your Product Size!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input addonAfter='"' />)}
                      </Form.Item>
                    </Col>
                    {this.state.category ===
                      "37638d60-2b19-11eb-b05c-a3fa7baaf1b5" && (
                      <Col lg={4} md={4} sm={24} xs={24}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span
                              style={{ color: "#7B8190", fontSize: "14px" }}
                            >
                              Price Per Supersack
                            </span>
                          }
                        >
                          {getFieldDecorator("supersack", {
                            rules: [
                              {
                                required: true,
                                message:
                                  "Please input your Product Price Per Supersack!",
                              },
                              noWhitespaceRule,
                            ],
                          })(<Input addonBefore="$" />)}
                        </Form.Item>
                      </Col>
                    )}

                    {/* <Col lg={4} md={4} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Price Per Ton
                          </span>
                        }
                      >
                        {getFieldDecorator("ton", {
                          rules: [
                            {
                              required: true,
                              message:
                                "Please input your Product Price Per Ton!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input addonBefore="$" />)}
                      </Form.Item>
                    </Col> */}
                    {/* <Col lg={4} md={4} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#7B8190", fontSize: "14px" }}>
                            Price Per Yard
                          </span>
                        }
                      >
                        {getFieldDecorator("yard", {
                          rules: [
                            {
                              required: true,
                              message:
                                "Please input your Product Price Per Yard!",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input addonBefore="$" />)}
                      </Form.Item>
                    </Col> */}
                    {this.state.category ===
                      "3f252db0-2b19-11eb-b05c-a3fa7baaf1b4" && (
                      <Col lg={4} md={4} sm={24} xs={24}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span
                              style={{ color: "#7B8190", fontSize: "14px" }}
                            >
                              Price Per Pallet
                            </span>
                          }
                        >
                          {getFieldDecorator("pallet", {
                            rules: [
                              {
                                required: true,
                                message:
                                  "Please input your Product Price Per Pallet!",
                              },
                              noWhitespaceRule,
                            ],
                          })(<Input addonBefore="$" />)}
                        </Form.Item>
                      </Col>
                    )}
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <Form.Item
                        label={
                          <span
                            style={{
                              color: "#7B8190",
                              fontSize: "14px",
                              marginLeft: "50px",
                            }}
                          >
                            Upload
                          </span>
                        }
                      >
                        {getFieldDecorator("sizeUploadImg", {
                          // rules: [{ required: this.props.match.params.id ? false : true, message: 'Please upload file!' }],
                        })(
                          <div className="addproduct-uploadbtn">
                            <Upload
                              {...props}
                              setFieldsValue={this.state.sizeUploadImg}
                            >
                              <Button>
                                <Icon type="upload" />
                                Upload
                              </Button>
                            </Upload>
                          </div>
                        )}
                      </Form.Item>
                    </Col>
                    {formItems}
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "3%" }}
                    >
                      <p
                        onClick={this.add}
                        style={{
                          marginLeft: "7px",
                          color: "#0E4D90",
                          lineHeight: "20px",
                          cursor: "pointer",
                        }}
                      >
                        {" "}
                        <PlusCircleOutlined /> &nbsp;Add More Size
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Form.Item style={{ float: "right", marginTop: "20px" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#25559517",
                          color: "#255595",
                          marginRight: "30px",
                          padding: "0 20px 0 20px",
                          border: "none",
                        }}
                      >
                        <Link to="/app/products">Cancel</Link>
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={this.state.loading}
                        onClick={this.handleSubmit}
                        style={{
                          backgroundColor: "#255595",
                          color: "white",
                          marginRight: "30px",
                          padding: "0 20px 0 20px",
                        }}
                      >
                        {this.state.btntitle}
                      </Button>
                    </Form.Item>
                  </Row>
                </Form>
              </Card>
            </div>
          </Col>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "addproduct" })(withRouter(AddProduct));
